import { render, staticRenderFns } from "./PendingInvitations.vue?vue&type=template&id=7559485c&"
import script from "./PendingInvitations.vue?vue&type=script&lang=js&"
export * from "./PendingInvitations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports